import { useEffect, useState, useRef } from "react"
import { useStyles } from "../../../style/styles"
import { IProps } from "./types"
import { Box, Grid, List, Typography, CircularProgress } from '@mui/material'
import { MessagePayload } from "../../../components/Chat/types"
import React from "react"
import ChatMessage from "../ChatMessage"
import { listChannelMessages } from "../../../lib/messageUtils"


const ChatList = (props: IProps) => {
  const classes = useStyles()
  const {
    channel,
    onLoadMessages,
    inputFocused,
    channelMetadata,
    user,
    initialNextToken,
    messageUpdateTrigger
  } = props

	const { channelArn } = channel
	const { userArn } = user
  const chatListRef = useRef<HTMLDivElement>(null)
  const [messageList, setMessageList] = useState<MessagePayload[] | null>(null)
  const [lastMessageRead, setLastMessageRead] = useState(null)
  const [lastMessage, setLastMessage] = useState<any>({})
  const hasScrolledToBottom = useRef(false)

  useEffect(() => {
    console.log('v2 chat list props', props)
		console.log('v2 chat list props 2', channelArn)
    if(channelArn) {
        listChannelMessages(channelArn, userArn).then((res) => {
            const listMessages = res
            const newMessages = listMessages?.Messages || []
            
            console.log('v2 list res: res', newMessages)
            const newNextToken = listMessages?.NextToken || null
            // TODO: add next token handling
            // TODO: add scrolling handling
            filterMessageList(newMessages)
        })
      }
    
    }, [channelArn, userArn])

    const filterMessageList = (messages: MessagePayload[]) => {
        console.log('v2 messages', messages)
        setMessageList(messages)
    }

    /* Reload messages when messageUpdateTrigger changes */
    useEffect(() => {
      if (messageUpdateTrigger && messageUpdateTrigger > 0 && channelArn) {
        console.log('v2: Reloading messages due to trigger', messageUpdateTrigger)
        listChannelMessages(channelArn, userArn).then((res) => {
          const listMessages = res
          const newMessages = listMessages?.Messages || []
          console.log('v2: Reloaded messages', newMessages)
          filterMessageList(newMessages)
        })
      }
    }, [messageUpdateTrigger])

    /* Scroll to bottom upon initial load */
    useEffect(() => {
      if (messageList && messageList.length > 0 && !hasScrolledToBottom.current) {
        const scrollToBottom = () => {
          if (chatListRef.current) {
            chatListRef.current.scrollTop = chatListRef.current.scrollHeight
          }
        };

        scrollToBottom();
        const timeoutId = setTimeout(scrollToBottom, 100);
        hasScrolledToBottom.current = true;
        return () => clearTimeout(timeoutId);
      }
    }, [messageList]);

    return (
        <div className={classes.chatListContainer}
            ref={chatListRef}
            // onClick={handleBodyClick}
        >
            <div className={classes.innerChatBody}>
                <div className={classes.messageWrapper}>
                    {/* TODO: Add loading for more messages fetching  */}
                <List>
                    {messageList && messageList.length > 0 && messageList.map((message, index) => {
                        /* TJSKR-2889: Find the actual previous message (for avatar display conditions) */
                        const actualLastReadMessage = lastMessageRead
                        ? [...messageList]
                            .reverse()
                            .find((m) => {
                                const arn = m?.Sender?.Arn;
                                if (!arn) return false;

                                const userIdFromArn = arn.split('/').pop();
                                return (
                                userIdFromArn === userArn &&
                                new Date(m.CreatedTimestamp) <= new Date(lastMessageRead)
                                );
                            })
                        : null;

                        let actualPrevMessage = null; 
                        if (index > 0) {
                        for (let i = index - 1; i >= 0; i--) {
                            const potentialPrevMessage = messageList[i]
                            if (new Date(potentialPrevMessage.CreatedTimestamp) < new Date(message.CreatedTimestamp)) {
                            actualPrevMessage = potentialPrevMessage
                            break
                            }
                        }
                        }

                        return (
                        <React.Fragment key={message.MessageId}>
                            <ChatMessage
                            message={message}
                            prevMessage={actualPrevMessage}
                            // userArn={userArn}
                            // isEndedConversation={isEndedConversation}
                            isLastMessage={index === messageList.length - 1}
                            // userType={userType}
                            // channelArn={channelArn || null}
														user={user}
														channel={channel}
                            // handleDeleteMessage={handleRemoveOrUndoMessage}
                            // connections={connections}
                            // timezone={timezone}
                            channelMetadata={channelMetadata ?? ''}
                            // endOrReenableActionDoer={endOrReenableActionDoer}
                            lastMessage={lastMessage}
                            />
                        </React.Fragment>
                        );
                    })}
                    {/* TODO: Arrow down button */}
                    </List>   
                </div>
            </div>

        </div>
    )
   


}

export default ChatList